<template>
<div class="chapter">
<div class="inner_page">
<p class="LINESPACE" id="epi"> </p>
<blockquote epub:type="epigraph" role="doc-epigraph">
<p class="EPV"><span aria-label=" Page vii. " epub:type="pagebreak" id="pg_vii" role="doc-pagebreak">God that berreth the crone of thornes</span></p>
<p class="EPV">Distru the prud of womens homes …</p>
<p class="EPC">Curse</p>
<p class="EPV">Mother, Mother, I am coming</p>
<p class="EPV">Home to Jesus</p>
<p class="EPV">And to Thee …</p>
<p class="EPC">Hymn</p>
</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?3a8ed388